/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientIdentifierType from './patient-identifier-type';
import PatientIdentifierTypeDetail from './patient-identifier-type-detail';
import PatientIdentifierTypeUpdate from './patient-identifier-type-update';
import PatientIdentifierTypeDeleteDialog from './patient-identifier-type-delete-dialog';

const PatientIdentifierTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientIdentifierType />} />
    <Route path="new" element={<PatientIdentifierTypeUpdate />} />
    <Route path=":id">
      <Route index element={<PatientIdentifierTypeDetail />} />
      <Route path="edit" element={<PatientIdentifierTypeUpdate />} />
      <Route path="delete" element={<PatientIdentifierTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientIdentifierTypeRoutes;
